import { render, staticRenderFns } from "./PurposesRentingAreasList.vue?vue&type=template&id=d04b5b28&scoped=true&"
import script from "./PurposesRentingAreasList.vue?vue&type=script&lang=js&"
export * from "./PurposesRentingAreasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04b5b28",
  null
  
)

export default component.exports